export default __webpack_public_path__ + "assets/images/ea9c17e6fe0a7b2e8fcb5d5a385cb624.svg";